import { QRCodeGenerator, UmotoLogo } from '@components';
import { AppConsts } from '@lib';
import { Col, Row, Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

const StyledQrTemplate = styled.div`
  padding: 1vh 2vw;
  text-align: center;
  flex-grow: 1;
  background: white;
  background-image: url('/qr-template-bg.png'), url('/qr-code-bg.png');
  background-position:
    bottom center,
    center 50vh;
  background-size: 90%, 120%;
  background-repeat: no-repeat, no-repeat;
  width: auto;
  height: auto;
  box-sizing: border-box;
  margin: auto;
  aspect-ratio: 1 / 1.414;

  @media screen {
    transform: scale(0.25) translateY(-820px);
    border: 2px dashed #ccc;
  }

  h1 {
    font-size: 38px;
  }
  h3 {
    font-size: 18px;
  }
  @media print {
    background-size: 90%, 110%;
    background-position:
      bottom center,
      center bottom;
    padding: 4vh 5vw;
    transform: scale(1);
    width: 100vw;
    height: 100vh;
    h1 {
      font-size: 9vw;
      padding: 0;
      margin: 0;
    }
    h3 {
      font-size: 3.5vw;
    }
  }
`;

const StyledLogoHolder = styled.div`
  margin: 4px 4px;
  aspect-ratio: 21 / 9;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20%;
  max-height: 8vh;

  img {
    object-fit: cover;
    max-height: 100%;
    max-width: 100%;
  }
  @media print {
    max-height: 8vh;
  }
`;

const StyledCompanyLogoHolder = styled(StyledLogoHolder)`
  border: 2px dashed #ccc;
`;

const StyledQRCodeHolder = styled.div`
  position: absolute;
  bottom: 15vh;
  left: 0;
  right: 0;
  max-width: 25%;
  margin: auto;

  div {
    border-radius: 1.5vw;
  }
`;
interface IProps {
  companyLogo?: string;
}

export const QRCodePrintTemplate: React.FC<IProps> = (props) => {
  return (
    <StyledQrTemplate>
      <Row>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'} style={{ paddingBottom: '4.5vh' }}>
            <Col>
              <StyledLogoHolder>{<UmotoLogo />}</StyledLogoHolder>
            </Col>
            <Col>
              <StyledCompanyLogoHolder>
                <img src={props.companyLogo} alt="CompanyLogo" />
              </StyledCompanyLogoHolder>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Title style={{ fontWeight: 'bold' }}>
            DOWNLOAD THE <br /> UMOTO APP
          </Title>
        </Col>
      </Row>
      <Row justify="center">
        <StyledQRCodeHolder>
          <QRCodeGenerator value={AppConsts.mobileAppUrl} />
        </StyledQRCodeHolder>
      </Row>
    </StyledQrTemplate>
  );
};
